import React from 'react';
import { connectField } from 'uniforms';

import RichTextEditor from '../../../RichTextEditor';

const RichTextField = RichTextEditor;

export default connectField(RichTextField);
